<template>
  <TextButton
    :class="{ active }"
    :disabled="disabled"
    type="button"
    v-on="$listeners">
    <span
      class="icon-text-button__icon mr-1"
      :class="outlined ? 'material-icons-outlined' : 'material-icons'"
      :style="{ fontSize: `${iconSize}px` }">
      {{ icon }}
    </span>
    <span class="icon-text-button__text">
      <slot />
    </span>
  </TextButton>
</template>

<script>
import TextButton from '@/components/parts/TextButton'
export default {
  components: {
    TextButton
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null,
    },
    outlined: {
      type: Boolean,
      default: false
    },
    iconSize: {
      type: [String, Number],
      default: null
    }
  },
}
</script>

<style lang="scss" scoped>
.icon-text-button {
  color: $grey05;
  cursor: pointer;
  width: fit-content;

  &.active {
    color: $l-blue;
  }

  &__icon {
    font-size: $fs-xl;
  }

  &__text {
    font-size: $fs-m;
  }
}

</style>